import { FC } from 'react';
import styled from 'styled-components';
import { SC_LIGHT_GRAY } from '../themes/DefaultTheme';

const ButtonToolbarElement = styled.div`
  margin: 0px;
  padding: 0px;
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: ${(props: any) =>
    props.align === 'center' ? 'center' : props.align === 'right' ? 'flex-end' : 'flex-start'};
  border-left: ${(props: any) => (props.dividerLeft ? '2px solid ' + SC_LIGHT_GRAY : 'none')};
  border-right: ${(props: any) => (props.dividerRight ? '2px solid ' + SC_LIGHT_GRAY : 'none')};

  && > *:first-child {
    margin-left: ${(props: any) => (props.dividerLeft ? '10px' : '0px')};
  }

  && > * {
    margin-right: 10px;
  }

  && > *:last-child {
    margin-right: ${(props: any) => (props.dividerRight ? '10px' : '0px')};
  }
`;

export type ButtonToolbarAlignment = 'left' | 'center' | 'right';

export interface IProps {
  align?: ButtonToolbarAlignment;
  dividerLeft?: boolean;
  dividerRight?: boolean;
}

export const ButtonToolbar: FC<IProps> = props => {
  return <ButtonToolbarElement {...props} data-testid="ButtonToolbar" />;
};
